import React from 'react';
import { useSelector } from 'react-redux';
import { CSpinner } from '@coreui/react';
import SummarySection from './sections/SummarySection';
import CustomerFeedback from './sections/CustomerFeedback';
import {
  selectLoadedInsightsStatus,
  selectLoadingInsightsStatus,
} from '../../store/selectors/insights.selectors';
import DailyPhaseVolume from './sections/DailyPhaseVolume';

const InsightsWidgetsPage = () => {
  const isLoading = useSelector(selectLoadingInsightsStatus);
  const loaded = useSelector(selectLoadedInsightsStatus);
  return (!isLoading && loaded) ? (
     <>
      <SummarySection />
      <CustomerFeedback />
      <DailyPhaseVolume />
     </>
  ) : (
    <div className="c-app c-default-layout flex-row align-items-center justify-content-center">
      <CSpinner
        className="primary-color"
        style={{width:'3rem', height:'3rem'}}
      />
    </div>
  );
};

export default InsightsWidgetsPage;
